import $ from 'jquery';
import ReloadableComponentPrototype from 'ReloadableComponentPrototype';
import _ from 'lodash';
import Cookies from 'cookies';
import { sendEventToGoogleAnalytics } from '../../../base/analytics/analyticsEvents';

export default class Navigation2019 extends ReloadableComponentPrototype {
  build() {
    this.notificationsHeight = 0;
    this.mainContainer = $('.main-container');
    this.navigationWrapper = $('#navigation-wrapper');
    this.openedLoginContainerClass = '.cms-navigation-2019__contents--login.cms-navigation-2019__contents--visible';
    this.tupasLink = $('.cms-login__panel--tupas .button');
    this.makeAdditionalCall();
    this.overrideAddSearchStyles();
    this.initShoppingCart();
    this.initSearch();
    this.initLogin();
    this.initMenu();
    this.toggleTopBarVisibilityOnScroll();
    this.addGeneralOverlayClickHandler();
    this.addResizeHandler();
    this.adjustViewportHeightToAccountForMobileToolbarOnIPhones();
    this.showLoginOnDisabledLinkClick();
    this.enableScrolling();
    this.openLoginAreaOnHashChange();
    this.oneLoginLanguageSelectionClickHandler();

    this.eventBus.subscribe(this, 'notification_height_change', this.onNotificationHeightChange);

    this.eventBus.subscribe(this, 'reload_navigation', () => {
      this.reload();
    });

    this.eventBus.subscribe(this, 'reload_navigation_login', () => {
      const loginComponentId = this.node.find('[data-component="login-2020"]').attr('data-component-id');
      this.eventBus.publishTo(loginComponentId, 'reload');
      this.hideLoginArea();
      this.hideGeneralOverlay();
      this.enableScrolling();
    });

    this.eventBus.subscribe(this, 'navigation_logout', () => {
      this.hideLoginArea();
      this.hideGeneralOverlay();
      this.enableScrolling();
    });

    this.sendGAEvents();
    this.toggleTopBarVisibility();
    this.handleInitialsButtonAriaExpanded();
    this.handleInitialsButtonNavigation();
    this.handleEscapeOnInitialsMenu();
    this.handleSkipElements();
    this.handleHashChange();
    this.toggleAriaExpandedHamburgerMenu();
  }

  scrollAndFocus() {
    let mainContent = $('#main-content');
    let focusableEls = mainContent.find('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
    if (focusableEls.length > 0) {
      let navbarHeight = $('.cms-navigation-2019').outerHeight(true);
      let notificationHeight = $('.notificationSection').outerHeight(true) || 0;
      let subNavHeight = $('.sub-nav').outerHeight(true) || 0;
      let additionalOffset = 10;
      $('html, body').animate({
        scrollTop: $('#main-content').offset().top - navbarHeight - notificationHeight - subNavHeight - additionalOffset
      }, 500);
      setTimeout(function () {
        focusableEls[0].focus();
      }, 100);
    }
  }
  handleSkipElements() {
    const skipLink = $('.cms-navigation-2019__skip-link');
    const skipChat = $('.cms-navigation-2019__skip-chat');
    let mainContent = $('#main-content');
    let chatExists = skipChat.length > 0;

    if (mainContent.length === 0 && !chatExists) {
      skipLink.parent().css('display', 'none'); // hide parent
    } else {
      skipLink.parent().css('display', ''); // show parent
      if (mainContent.length === 0) {
        skipLink.css('display', 'none');
        skipChat.addClass('skip-link-absent'); // add class to skip-chat
      } else {
        skipLink.css('display', '');
        skipChat.removeClass('skip-link-absent'); // remove class from skip-chat
        this.handleSkipLink();
      }
      if (chatExists) {
        this.handleSkipToChat();
      }
    }
  }
  handleSkipLink() {
    const skipLink = $('.cms-navigation-2019__skip-link');
    skipLink.on('click', (event) => {
      event.preventDefault();
      window.location.hash = 'main-content';
      this.scrollAndFocus();
    });
  }

  handleSkipToChat() {
    const skipChat = $('.cms-navigation-2019__skip-chat');
    skipChat.on('click', (event) => {
      event.preventDefault();
      DIALOGUE.api.showChat(true);
      DIALOGUE.api.expandChat();
    });
  }

  handleHashChange() {
    $(window).on('hashchange', () => {
      if (window.location.hash === '#main-content') {
        setTimeout(() => {
          this.scrollAndFocus();
        }, 1000);
      }
    });
    // triggering the hashchange event on page load to handle the case when the page is loaded with a hash
    $(window).trigger('hashchange');
  }

  openLoginAreaOnHashChange() {
    $(window).on('hashchange', () => {
      if (location.hash === '#kirjaudu') {
        if (!this.isLoggedIn()) {
          this.redirectToNewLoginPage('currentPage', '', false);
        }
      }
    });
  }

  sendGAEvents() {
    sendEventToGoogleAnalytics({
      event: 'gaEvent',
      eventCategory: 'debug',
      eventAction: 'navigation js executed',
    });
  }

  onNotificationHeightChange(heightDifference) {
    this.notificationsHeight += heightDifference;

    if (this.notificationsHeight > 0) {
      this.mainContainer.css('padding-top', this.navigationWrapper.height() + this.notificationsHeight);
    } else {
      this.mainContainer.css('padding-top', '');
    }

    this.adjustSearchPosition();
  }

  adjustSearchPosition() {
    const searchInputWrapper = this.node.find('.cms-navigation-2019__search-input-wrapper');

    if (!this.isInDesktopSize() && searchInputWrapper.hasClass('cms-navigation-2019__search-input-wrapper--active')) {
      searchInputWrapper.css('top', this.notificationsHeight);
    } else {
      searchInputWrapper.removeAttr('style');
    }
  }

  overrideAddSearchStyles() {
    window.addsearch_settings = { results_box_css_classname: 'cms-navigation-2019-compatible' };
  }

  initShoppingCart() {
    this.shoppingCartElement = this.node.find('.cms-navigation-2019__icon-menu-item--cart');

    if (this.data.shoppingCartType === 'B2C') {
      const oldB2CeShopShoppingCartCount = Cookies.get(this.data.oldB2CCartCookieName);
      const newB2CeComShoppingCartCount = Cookies.get(this.data.newB2CCartCookieName);
      const oldB2CeShopShoppingCartCountInt = oldB2CeShopShoppingCartCount === undefined ? 0 : parseInt(oldB2CeShopShoppingCartCount, 10);
      const newB2CeComShoppingCartCountInt = newB2CeComShoppingCartCount === undefined ? 0 : parseInt(newB2CeComShoppingCartCount, 10);
      const totalCartCount = oldB2CeShopShoppingCartCountInt + newB2CeComShoppingCartCountInt;
      this.updateShoppingCartUrlforB2C(oldB2CeShopShoppingCartCountInt, newB2CeComShoppingCartCountInt, totalCartCount);
      this.updateShoppingCartAmount(totalCartCount);
    } else if (this.data.shoppingCartType === 'B2B') {
      this.getNewB2BeComShoppingCartCount();
    }
  }


  getNewB2BeComShoppingCartCount() {
    const newB2BcartAmount = Cookies.get(this.data.newB2BCartCookieName);
    if (newB2BcartAmount) {
      this.updateShoppingCartAmount(newB2BcartAmount);
    } else {
      this.updateShoppingCartAmount(0);
    }
  }

  updateShoppingCartUrlforB2C(oldB2CeShopShoppingCartCount, newB2CeComShoppingCartCount, totalCartCount) {
    if (totalCartCount > 1 && oldB2CeShopShoppingCartCount >= 1 && newB2CeComShoppingCartCount >= 1) {
      this.shoppingCartElement.attr('href', this.data.bothB2CShopCartAnchor);
    } else if (totalCartCount > 1 && oldB2CeShopShoppingCartCount > 1) {
      this.shoppingCartElement.attr('href', this.data.shoppingCartUrl);
    } else if (totalCartCount > 1 && newB2CeComShoppingCartCount > 1) {
      this.shoppingCartElement.attr('href', this.data.newB2CCartUrl);
    } else if (totalCartCount === 1 && oldB2CeShopShoppingCartCount === 1) {
      this.shoppingCartElement.attr('href', this.data.shoppingCartUrl);
    } else if (totalCartCount === 1 && newB2CeComShoppingCartCount === 1) {
      this.shoppingCartElement.attr('href', this.data.newB2CCartUrl);
    }
  }

  updateShoppingCartAmount(amount) {
    const cartAmount = this.node.find('.cms-navigation-2019__cart-amount');

    if (amount > 0) {
      const cartAmountNumber = this.node.find('.cms-navigation-2019__cart-amount-number');
      cartAmountNumber.text(amount);
      cartAmount.css('display', 'flex');
    } else {
      cartAmount.css('display', 'none');
    }
  }

  initSearch() {
    this.addSearchIconClickHandler();
    this.addSearchCloseIconClickHandler();
    this.addSearchOverlayClickHandler();
    this.addSearchInputKeydownHandler();
    this.submitWhenEnterIsClickedOnSearchInput();

  }

  oneLoginLanguageSelectionClickHandler() {
    const oneLoginLanguageLink = this.node.find('.cms-navigation-2019__language-onelogin');
    oneLoginLanguageLink.on('click', () => {
      window.sessionStorage.setItem('languageSelectedInOneLogin', true);
    });
  }

  submitWhenEnterIsClickedOnSearchInput() {
    this.searchFormInput = this.node.find('.cms-navigation-2019__search-input');
    this.searchFormInput.on('keydown', (evt) => {
      if (evt.key === 'Enter') {
        this.submitSearchForm();
      }
    });
  }

  addSearchIconClickHandler() {
    const searchInputWrapper = this.node.find('.cms-navigation-2019__search-input-wrapper');
    const searchIcon = this.node.find('.cms-navigation-2019__search-icon');

    searchIcon.on('click', () => {
      const searchIsActive = searchInputWrapper.hasClass('cms-navigation-2019__search-input-wrapper--active');

      if (searchIsActive) {
        this.submitSearchForm();
      } else {
        this.activateSearch();
      }
    });
  }

  addSearchCloseIconClickHandler() {
    const searchCloseIcon = this.node.find('.cms-navigation-2019__search-close-icon');

    searchCloseIcon.on('click', () => {
      this.deactivateSearch();
    });
  }

  addSearchOverlayClickHandler() {
    const searchOverlay = this.node.find('.cms-navigation-2019__search-overlay');

    searchOverlay.on('click', () => {
      this.deactivateSearch();
    });
  }

  submitSearchForm() {
    const searchForm = this.node.find('.cms-navigation-2019__search-form');
    const searchFormAction = searchForm.attr('action');
    this.searchFormInput = this.node.find('.cms-navigation-2019__search-input');
    const searchFormInputValue = this.searchFormInput.val().replace(/\+/g, '%20').replace(/(<([^>]+)>)/ig, '');
    if (searchFormInputValue.length > 0) {
      this.searchFormInput.attr('value', searchFormInputValue);
    }
    const redirectUrl = `${searchFormAction}?q=${searchFormInputValue}`;
    window.location.href = redirectUrl;
  }

  // method introduced to store the currently focused element
  storeCurrentFocus() {
    // Store the currently focused element
    this.lastFocusedElement = document.activeElement;
  }

  // method introduced to restore the previously focused element
  restorePreviousFocus() {
    // Restore focus to the last focused element
    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus();
      this.lastFocusedElement = null;
    }
  }

  activateSearch() {
    this.storeCurrentFocus();
    this.slideHideMenu();
    this.showSearchInput();
    this.focusOnSearchInput();
    this.showSearchOverlay();
    this.hideLoginArea();
    this.hideMobileMenu();
    this.collapseAllMenus();
    this.hideGeneralOverlay();
    this.disableScrolling();
  }

  deactivateSearch() {
    this.hideSearchOverlay();
    this.hideSearchInput();
    this.clearSearchInput();
    this.slideShowMenu();
    this.enableScrolling();
    this.restorePreviousFocus();
  }
  showSearchInput() {
    const searchInputWrapper = this.node.find('.cms-navigation-2019__search-input-wrapper');
    searchInputWrapper.addClass('cms-navigation-2019__search-input-wrapper--active');
    this.adjustSearchPosition();
  }

  focusOnSearchInput() {
    const searchInput = this.node.find('.cms-navigation-2019__search-input');
    searchInput.focus();
  }

  hideSearchInput() {
    const searchInputWrapper = this.node.find('.cms-navigation-2019__search-input-wrapper');
    searchInputWrapper.removeClass('cms-navigation-2019__search-input-wrapper--active');
    this.adjustSearchPosition();
  }

  clearSearchInput() {
    const addSearch = window.addsearch;

    if (addSearch) {
      addSearch.closeAndReset();
    }
  }

  addSearchInputKeydownHandler() {

    // handling the escape key and tab key press on the search input
    const searchInput = $('.cms-navigation-2019__search-input');
    searchInput.on('keydown', (event) => {
      if (event.key === 'Escape' || event.key === 'Tab') {
        this.deactivateSearch();
      }
    });
  };

  slideHideMenu() {
    const menuContainer = this.node.find('.cms-navigation-2019__menu-container');
    menuContainer.addClass('cms-navigation-2019__menu-container--slide-hidden');
  }

  slideShowMenu() {
    const menuContainer = this.node.find('.cms-navigation-2019__menu-container');
    menuContainer.removeClass('cms-navigation-2019__menu-container--slide-hidden');
  }

  hideSearchOverlay() {
    const searchOverlay = this.node.find('.cms-navigation-2019__search-overlay');
    searchOverlay.removeClass('cms-navigation-2019__search-overlay--visible');
  }

  showSearchOverlay() {
    const searchOverlay = this.node.find('.cms-navigation-2019__search-overlay');
    searchOverlay.addClass('cms-navigation-2019__search-overlay--visible');
  }

  toggleTopBarVisibilityOnScroll() {
    $(window).on('scroll', () => {
      if (this.scrollEnabled) {
        this.toggleTopBarVisibility();
      }
    });
  }

  toggleTopBarVisibility() {
    const topBarHeight = 38;
    const topBar = this.node.find('.cms-navigation-2019__top-bar');
    const scrollPosition = $(document).scrollTop();

    if (scrollPosition > topBarHeight) {
      topBar.addClass('cms-navigation-2019__top-bar--hidden');
    } else {
      topBar.removeClass('cms-navigation-2019__top-bar--hidden');
    }
  }

  initLogin() {
    this.addLoginIconClickHandler();

    if (this.data.loginOpenOnLoad) {
      if (!this.isLoggedIn()) {
        this.redirectToNewLoginPage('currentPage', '', true);
      }
    }
  }

  addLoginIconClickHandler() {
    const loginIcon = this.node.find('.cms-navigation-2019__icon-menu-item--login');
    const loginArea = this.node.find('.cms-navigation-2019__contents--login');

    loginIcon.on('click', () => {
      if (!this.isLoggedIn()) {
        this.redirectToNewLoginPage('currentPage', '', false);
      } else {
        const loginAreaVisible = loginArea.hasClass('cms-navigation-2019__contents--visible');
        if (loginAreaVisible) {
          this.hideLoginArea();
          this.hideGeneralOverlay();
          this.enableScrolling();
        } else {
          this.adjustViewportHeightToAccountForMobileToolbarOnIPhones();
          this.showLoginArea();
          this.hideMobileMenu();
          this.collapseAllMenus();
          this.showGeneralOverlay();
          this.enableLoginInputs();
          this.disableScrolling();
        }
      }
    });
  }

  redirectToNewLoginPage(type, url, replaceKirjaudu) {
    let successUrl;
    let language;
    let redirectedUrl;
    if (type === 'currentPage') {
      successUrl = window.location.href;
    } else {
      successUrl = url;
    }
    if (replaceKirjaudu) {
      successUrl = successUrl.replace('?kirjaudu', '');
    }
    if (this.node.data('sitename') === 'teliafiyrityksille_english') {
      language = 'en';
    } else if (successUrl.includes('/english')) {
      language = 'en';
    } else if (successUrl.includes('/svenska')) {
      language = 'sv';
    }
    const loginPageUrl = this.data.loginRedirectPage;
    if (language) {
      redirectedUrl = `${loginPageUrl}?redirect=${successUrl}&lang=${language}`;
    } else {
      redirectedUrl = `${loginPageUrl}?redirect=${successUrl}`;
    }
    window.location.href = redirectedUrl.split('#kirjaudu')[0];
  }

  isLoggedIn() {
    const loginStatus = this.node.find('.cms-navigation-2019__login-status');
    return loginStatus.hasClass('cms-navigation-2019__login-status--logged-in');
  }

  hideLoginArea() {
    const loginArea = this.node.find('.cms-navigation-2019__contents--login');

    if (this.isLoggedIn()) {
      $('.sub-nav').show();
    }

    loginArea.removeClass('cms-navigation-2019__contents--visible');

    if (this.notificationsHeight) {
      loginArea.removeAttr('style');
    }

    this.removeHash();

    setTimeout(() => {
      this.showLoginStatusIcon();
      this.hideLoginCloseIcon();
    }, 200); // that's how long it takes to animate login closing
  }

  removeHash() {
    history.pushState('', document.title, window.location.pathname + window.location.search);
  }

  showLoginArea() {
    const loginArea = this.node.find('.cms-navigation-2019__contents--login');

    if (this.isLoggedIn()) {
      $('.sub-nav').hide();
    }

    loginArea.addClass('cms-navigation-2019__contents--visible');

    if (this.notificationsHeight) {
      setTimeout(() => {
        this.handleLoginMaxHeight();
      }, 200); // that's how long it takes to animate login opening
    }

    this.hideLoginStatusIcon();
    this.showLoginCloseIcon();
  }

  showLoginStatusIcon() {
    const loginStatusIcon = this.node.find('.cms-navigation-2019__login-status');
    loginStatusIcon.show();
  }

  hideLoginStatusIcon() {
    const loginStatusIcon = this.node.find('.cms-navigation-2019__login-status');
    loginStatusIcon.hide();
  }

  showLoginCloseIcon() {
    const loginCloseIcon = this.node.find('.cms-navigation-2019__login-close-icon');
    loginCloseIcon.show();
  }

  hideLoginCloseIcon() {
    const loginCloseIcon = this.node.find('.cms-navigation-2019__login-close-icon');
    loginCloseIcon.hide();
  }

  toggleAriaExpanded(selector, condition) {
    const element = this.node.find(selector);
    element.attr('aria-expanded', condition ? 'true' : 'false');
  }

  // New method to set aria-expanded for both buttons
  setAriaExpandedForBothButtons(value) {
    this.toggleAriaExpanded('.cms-navigation-2019__login-status--logged-in', value);
    this.toggleAriaExpanded('.cms-navigation-2019__login-close-icon', value);
  }

  // Updated handleInitialsButtonAriaExpanded method
  handleInitialsButtonAriaExpanded() {
    let initialsButton = $('.cms-navigation-2019__login-status--logged-in');
    let closeButton = $('.cms-navigation-2019__login-close-icon');

    initialsButton.click(() => {
      this.setAriaExpandedForBothButtons(true); // Call the new method
    });

    closeButton.click(() => {
      this.setAriaExpandedForBothButtons(false); // Call the new method
    });
  }
  // Main method to handle the navigation of the initials button
  handleInitialsButtonNavigation() {
    // Select the initials button element
    let self = this;
    let initialsButton = $('.cms-navigation-2019__login-status--logged-in');
    let closeButton = $('.cms-navigation-2019__login-close-icon');
    let initialsServicesListLinks = $('.cms-login__services-list a');
    let initialsLoggedInLinks = $('.cms-navigation-2019__login-bottom-link-container--logged-in a');
    let combinedLinks = initialsServicesListLinks.add(initialsLoggedInLinks);
    let focusableElements = self.getAllFocusableElements();
    let nextFocusableElement = focusableElements.eq(focusableElements.index(initialsButton) + 1);
    let previousFocusableElement = focusableElements.eq(focusableElements.index(initialsButton) - 1);

    // Added a keydown event listener to the initials button
    initialsButton.on('keydown', function (e) {
      if (e.key === 'Tab' && !e.shiftKey && $(this).attr('aria-expanded') === 'false') {
        e.preventDefault();
        nextFocusableElement.focus();
      } else if (e.key === 'Tab' && e.shiftKey && $(this).attr('aria-expanded') === 'false') {
        e.preventDefault();
        previousFocusableElement.focus();
      } else if (e.key === 'Enter') {
        e.preventDefault();
        $(this).click(); // simulate click event
        closeButton.focus();
      } else if (e.key === 'Tab' && $(this).attr('aria-expanded') === 'true') {
        e.preventDefault();
        combinedLinks.first().focus();
      }
    });

    nextFocusableElement.on('keydown', function (e) {
      if (e.key === 'Tab' && e.shiftKey && initialsButton.attr('aria-expanded') === 'false') {
        e.preventDefault();
        initialsButton.focus();
      }
    });

    closeButton.on('keydown', function (e) {
      if (e.key === 'Enter') {
        setTimeout(function () {
          // Checking if the dropdown menu is closed
          if (initialsButton.attr('aria-expanded') === 'false') {
            // If it is, then move focus to the initialsButton
            initialsButton.focus();
          }
        }, 250);

      }
    });
    // Adding a blur event handler to the last element in combinedLinks
    // Updated blur event handler
    combinedLinks.last().on('blur', function () {
      self.hideLoginArea();
      self.hideGeneralOverlay();
      self.enableScrolling();
      self.setAriaExpandedForBothButtons(false);
      nextFocusableElement.focus();
    });
  }

  handleEscapeOnInitialsMenu() {
    let initialsButton = $('.cms-navigation-2019__login-status--logged-in');

    // Stores the reference to the correct context of `this`outside of the event handler to call on correct object
    let self = this;

    $(document).on('keydown', function (event) {
      if (event.key === 'Escape' && initialsButton.attr('aria-expanded') === 'true') {

        self.hideLoginArea();
        self.hideGeneralOverlay();
        self.enableScrolling();
        self.setAriaExpandedForBothButtons(false);
        setTimeout(function () {
          initialsButton.focus();
        }, 250);
      }
    });
  }
  handleLoginMaxHeight() {
    const openedLoginContainer = $(this.openedLoginContainerClass);
    const loginContainerMaxHeight = parseInt(openedLoginContainer.css('max-height'), 10);
    this.setNewLoginMaxHeightBasedOnVisibleNotifications(loginContainerMaxHeight);
  }

  setNewLoginMaxHeightBasedOnVisibleNotifications(maxHeight) {
    $(this.openedLoginContainerClass).css('max-height', maxHeight - this.notificationsHeight);
  }

  disableScrolling() {
    this.scrollPosition = window.pageYOffset;
    this.scrollEnabled = false;

    const $body = document.querySelector('body');
    $body.style.overflow = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `-${this.scrollPosition}px`;
    $body.style.width = '100%';
  }

  enableScrolling() {
    const $body = document.querySelector('body');
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');

    if (this.scrollPosition) {
      window.scrollTo(0, this.scrollPosition); // This triggers the scroll event
    }

    this.scrollEnabled = true;
  }

  hideGeneralOverlay() {
    const overlay = $('.cms-navigation-2019__general-overlay');
    overlay.removeClass('cms-navigation-2019__general-overlay--visible');
  }

  showGeneralOverlay() {
    const overlay = $('.cms-navigation-2019__general-overlay');
    overlay.addClass('cms-navigation-2019__general-overlay--visible');
  }

  enableLoginInputs() {
    // TODO: This could be done perhaps using the ppr event bus
    const loginInputs = $('.cms-login__panel .text-input__field');

    loginInputs.prop('disabled', false);
  }

  initMenu() {
    this.addMenuIconClickHandler();
    this.addMenuDropdownClickHandler();
    this.initKeydownHandlers();
  }

  addMenuIconClickHandler() {
    const menuIcon = this.node.find('.cms-navigation-2019__icon-menu-item--menu');

    menuIcon.on('click', () => {
      const isMobileMenuOpen = this.isMobileMenuOpen();

      if (isMobileMenuOpen) {
        this.hideMobileMenu();
        this.collapseAllMenus();
        this.hideGeneralOverlay();
        this.enableScrolling();
      } else {
        this.adjustViewportHeightToAccountForMobileToolbarOnIPhones();
        this.showPrimaryMenu();
        this.hideLoginArea();
        this.showGeneralOverlay();
        this.disableScrolling();
      }
    });
  }

  isMobileMenuOpen() {
    const menuContainer = this.node.find('.cms-navigation-2019__menu-container');
    return menuContainer.hasClass('cms-navigation-2019__menu-container--visible');
  }

  hideMobileMenu() {
    const menuContainer = this.node.find('.cms-navigation-2019__menu-container');
    menuContainer.removeClass('cms-navigation-2019__menu-container--visible');
  }

  showPrimaryMenu() {
    const menuContainer = this.node.find('.cms-navigation-2019__menu-container');
    menuContainer.addClass('cms-navigation-2019__menu-container--visible');
    this.activateHamburger();
  }

  collapseAllMenus() {
    const selectedMenus = this.node.find('.cms-navigation-2019__menu-item--selected');
    this.collapseMenu(selectedMenus);
    this.deactivateHamburger();
  }

  activateHamburger() {
    const hamburger = this.node.find('.cms-navigation-2019__hamburger');
    hamburger.addClass('cms-navigation-2019__hamburger--active');
    this.toggleAriaExpanded('.cms-navigation-2019__hamburger', true);
  }

  showChatAndServiceMenu() {
    const chatButtonSection = $('.novelty-main-button-section');
    const serviceButtonSection = $('#kampyleButtonContainer');
    const videoBot = $('#videobot');
    chatButtonSection.css('display', 'block');
    serviceButtonSection.css('display', 'block');
    videoBot.css('display', 'block');
  }

  hideChatAndServiceMenu() {
    const chatButtonSection = $('.novelty-main-button-section');
    const serviceButtonSection = $('#kampyleButtonContainer');
    const videoBot = $('#videobot');
    chatButtonSection.css('display', 'none');
    serviceButtonSection.css('display', 'none');
    videoBot.css('display', 'none');
  }

  deactivateHamburger() {
    const hamburger = this.node.find('.cms-navigation-2019__hamburger');
    hamburger.removeClass('cms-navigation-2019__hamburger--active');
    this.toggleAriaExpanded('.cms-navigation-2019__hamburger', false);
  }

  addMenuDropdownClickHandler() {
    const menuItemDropdown = this.node.find('.cms-navigation-2019__menu-item--dropdown');

    menuItemDropdown.on('click', (event) => {
      event.stopPropagation();

      const clickedMenuItemDropdown = $(event.delegateTarget);
      const isSelected = clickedMenuItemDropdown.hasClass('cms-navigation-2019__menu-item--selected');

      if (isSelected) {
        this.collapseMenu(clickedMenuItemDropdown);
        const isAnyPrimaryMenuSelected =
          this.node.find('.cms-navigation-2019__menu--level-1 > .cms-navigation-2019__menu-item--selected').length > 0;

        if (this.isInDesktopSize() && !isAnyPrimaryMenuSelected) {
          this.hideGeneralOverlay();
          this.deactivateHamburger();
          this.hideMobileMenu();
          this.enableScrolling();
        }
      } else {
        this.closeOtherSameLevelMenus(clickedMenuItemDropdown);
        this.expandMenu(clickedMenuItemDropdown);
        this.hideLoginArea();
        this.showGeneralOverlay();
        this.showPrimaryMenu(); // To make sure mobile menu is visible when a primary menu item is clicked on desktop
        this.keepSubMenuInsideWindow();
        this.disableScrolling();
      }
    });
  }
  // main method holding all the keydown handlers
  initKeydownHandlers() {
    this.handleTopLevelNavigation();
    this.handleSecondLevelNavigation();
    this.handleEscapeKeyOnNavigation();
    this.tabOrderMobileView();
  }

  // Gets all focusable elements at the top level and not ones inside the level 2 and 3 menus
  getAllFocusableElements() {
    // Get all focusable elements outside the Shadow DOM
    let focusableElements = $('a, button, :input, [tabindex]').not('[tabindex="-1"], :disabled, .cms-navigation-2019__menu--level-2 *, .cms-navigation-2019__menu--level-3 *, .cms-login__services-list a, .cms-navigation-2019__login-bottom-link-container--logged-in a').filter(':visible');

    // Get the <telia-breadcrumbs> component
    let breadcrumbs = document.querySelector('telia-breadcrumbs');

    if (breadcrumbs) {
      // Get all telia-breadcrumbs-item components
      let breadcrumbItems = breadcrumbs.querySelectorAll('telia-breadcrumbs-item');

      // Excluding out telia-breadcrumbs-item components that are not currently visible. 
      // This is done by checking the offsetParent property of each component. If offsetParent is null, it means the component is not visible, and it is excluded.
      // converting a NodeList of breadcrumbItems into an array and then filtering out any items that are not currently visible on the pag
      breadcrumbItems = Array.from(breadcrumbItems).filter(item => item.offsetParent !== null);

      // Get all links inside the visible breadcrumb items
      let breadcrumbLinks = breadcrumbItems.reduce((links, item) => {
        return links.concat(Array.from(item.querySelectorAll('a')));
      }, []);

      // Add the breadcrumb links to the focusableElements
      focusableElements = focusableElements.add($(breadcrumbLinks));
    }

    return focusableElements;
  }
  // get all the first level elements i.e, the buttons
  getFirstLevelElements() {
    return $('.cms-navigation-2019__menu--level-1 > .cms-navigation-2019__menu-item--dropdown > button');
  }
  // gets all the second level elements i.e., buttons and anchors
  getSecondLevelElements(topLevelButton) {
    return topLevelButton.siblings('.cms-navigation-2019__menu--level-2').children('.cms-navigation-2019__menu-item').children('button, a');
  }
  // gets all the third level elements i.e., anchors
  getThirdLevelElements(secondLevelButton) {
    return secondLevelButton.siblings('.cms-navigation-2019__menu--level-3').children('.cms-navigation-2019__menu-item').children('a');
  }

  // Gets the accessible element's index that precedes the first top level navigation element i.e., Telia logo
  getFocusableElementBeforeFirstLevelNavigationElements() {
    // Get all focusable elements.
    const focusableElements = this.getAllFocusableElements();
    // Get Level 1 elements.
    const firstLevelElements = this.getFirstLevelElements();
    // Get the first element in firstLevelElements.
    const firstFirstLevelElement = firstLevelElements.first();
    // Get the index of the first top-level navigation element .
    const firstFirstLevelELementIndex = focusableElements.index(firstFirstLevelElement);
    // Return the accessible element that precedes the first top-level navigation elements
    return focusableElements.eq(firstFirstLevelELementIndex - 1);
  }

  // Gets the next focusable element index after the first level navigation elements
  getFocusableElementAfterFirstLevelNavigationElements() {
    // Get all focusable elements.
    const focusableElements = this.getAllFocusableElements();
    // Get Level 1 elements.
    const firstLevelElements = this.getFirstLevelElements();
    // Get the last element in firstLevelElements.
    const lastFirstLevelElement = firstLevelElements.last();
    // Find the index of the lastFirstLevelElement in focusableElements.
    const lastFirstLevelElementIndex = focusableElements.index(lastFirstLevelElement);
    // The index of the next focusable element would be lastFirstLevelElementIndex + 1.
    const nextFocusableElementIndex = lastFirstLevelElementIndex + 1;
    // Return the next focusable element.
    return focusableElements.eq(nextFocusableElementIndex);
  }

  handleShiftTab(e, index, element, firstLevelElements, focusableElements) {
    e.preventDefault();
    const currentlyFocusedElementIndex = focusableElements.index($(document.activeElement));
    const isFocusedElementFirstAfterFirstLevel = currentlyFocusedElementIndex === index + 1;
    const isFocusedElementFirstInFirstLevel = index === 0;

    // If the currently focused element is the first accessible element after the first level elements, shift the focus to the last element within the first level elements.
    if (isFocusedElementFirstAfterFirstLevel) {
      element.focus();
    }
    // If the focus is currently on the first element within the first level elements, shift the focus to the last accessible element that precedes the first level elements.
    else if (isFocusedElementFirstInFirstLevel) {
      this.getFocusableElementBeforeFirstLevelNavigationElements().focus();
    }
    // If the currently focused element is not the first one in the first level elements, move the focus to the previous element in the first level elements.
    else {
      const previousElement = firstLevelElements.eq(index - 1);
      const isPreviousElementExpanded = previousElement.attr('aria-expanded') === 'true';

      if (isPreviousElementExpanded) {
        const secondLevelElements = this.getSecondLevelElements(previousElement);
        const lastSecondLevelElement = secondLevelElements.last();
        const isLastSecondLevelElementButtonExpanded = lastSecondLevelElement.prop('tagName') === 'BUTTON' && lastSecondLevelElement.attr('aria-expanded') === 'true';

        if (isLastSecondLevelElementButtonExpanded) {
          const thirdLevelItems = this.getThirdLevelElements(lastSecondLevelElement);
          // If the previous button's submenu is expanded, move inside the submenu
          thirdLevelItems.length > 0 ? thirdLevelItems.last().focus() : secondLevelElements.last().focus();
        } else {
          secondLevelElements.last().focus();
        }
      } else {
        // If the previous button's submenu is not expanded, focus on the previous button
        previousElement.focus();
      }
    }
  }

  // Handles 'Tab' key press on first level elements.
  handleTab(e, index, element, firstLevelElements) {
    let isExpanded = element.attr('aria-expanded') === 'true';

    // If submenu is not expanded, focus on next element or first focusable element after first level elements.
    if (!isExpanded) {
      e.preventDefault();
      (index + 1 < firstLevelElements.length ? firstLevelElements.eq(index + 1) : this.getFocusableElementAfterFirstLevelNavigationElements()).focus();
    }
  }

  // Handles keydown events on first level elements basically what to do when 'Tab' or 'Shift+Tab' is pressed. Have refactored it so that the above methods handleTab and handleShiftTab are called.
  handleTopLevelNavigation() {
    const firstLevelElements = this.getFirstLevelElements();
    const focusableElements = this.getAllFocusableElements();
    let lastFirstLevelElement = firstLevelElements.last();
    let lastFirstLevelElementIndexFromAllFocusableElements = focusableElements.index(lastFirstLevelElement);
    let nextFocusableElementAfterFirstLevelElements = focusableElements.eq(lastFirstLevelElementIndexFromAllFocusableElements + 1);

    // Add the event listener to the element after first level elements so that when shift + tab is pressed the focus returns to the last focusable element in the first level navigation
    nextFocusableElementAfterFirstLevelElements.on('keydown', (e) => {
      if (e.key === 'Tab' && e.shiftKey) {
        this.handleShiftTab(e, lastFirstLevelElementIndexFromAllFocusableElements, lastFirstLevelElement, firstLevelElements, focusableElements);
      }
    });

    // Assign 'Tab' and 'Shift+Tab' keydown events to each first-level menu element for keyboard navigation
    firstLevelElements.each((index, element) => {
      element = $(element);
      element.on('keydown', (e) => {
        if (e.key === 'Tab' && e.shiftKey) {
          this.handleShiftTab(e, index, element, firstLevelElements, focusableElements);
        } else if (e.key === 'Tab') {
          this.handleTab(e, index, element, firstLevelElements);
        }
      });
    });
  }

  // Had to create a separate method for tabbing as the logic of tabbing at first and second level are fairly different and there is a lot of scenarios to consider.

  handleTabSecondLevel(e, index, secondLevelElement, secondLevelElements, topLevelButton, firstLevelElements) {
    // Prevent default 'Tab' key behavior
    e.preventDefault();

    const isButton = secondLevelElement.prop('tagName') === 'BUTTON';
    const isAnchor = secondLevelElement.prop('tagName') === 'A';
    const isExpanded = secondLevelElement.attr('aria-expanded') === 'true';
    const isCollapsed = secondLevelElement.attr('aria-expanded') === 'false';
    const isLastElement = index === secondLevelElements.length - 1;
    const nextElement = secondLevelElements[index + 1];
    const nextTopLevelButton = firstLevelElements[firstLevelElements.index(topLevelButton) + 1];
    const lastElement = secondLevelElements.last();
    const nextFocusableElement = this.getFocusableElementAfterFirstLevelNavigationElements();

    // Check if current element is a collapsed button or an anchor and if there is a next element move focus to it. 
    // Else if it's an expanded button, move focus to the first element in the third level menu
    // Else if it's the last element and it's an anchor or a collapsed button, move focus to the next top level button
    if ((isButton && isCollapsed || isAnchor) && nextElement) {
      nextElement.focus();
    }
    else if (isButton && isExpanded) {
      const thirdLevelItems = this.getThirdLevelElements(secondLevelElement);
      if (thirdLevelItems.length > 0) {
        thirdLevelItems[0].focus();
      }
    }
    // Check if current element is the last in the second level menu 
    else if (isLastElement && nextTopLevelButton && (isAnchor || (isButton && isCollapsed))) {
      nextTopLevelButton.focus();
    }


    // Condition to check if the focus has reached the last element in the sub menu of the last first level elements
    // Conditions are only used once in the function, so it's not necessary to store it in a variable 
    // Also the variables in the if block are not used anywhere else in the parent method so its better to keep them separate
    if ((firstLevelElements.index(topLevelButton) === firstLevelElements.length - 1) && index === secondLevelElements.length - 1) {
      const isAnchor = lastElement.prop('tagName') === 'A';
      const isButton = lastElement.prop('tagName') === 'BUTTON';
      const isButtonCollapsed = isButton && lastElement.attr('aria-expanded') === 'false';
      const isButtonExpanded = isButton && lastElement.attr('aria-expanded') === 'true';

      // Declare variables for the selectors and elements used in the conditions
      let immediateParentWithSelector;
      let thirdLevelElements;
      let self;

      // Check if the last element is an anchor
      if (isAnchor) {
        // Find immediate parent that matches selector, so used .closest()
        immediateParentWithSelector = secondLevelElement.closest('.cms-navigation-2019__menu-item--dropdown');
        this.collapseMenu(immediateParentWithSelector);
        nextFocusableElement.focus();
        this.hideGeneralOverlay();
        this.enableScrolling();
      }
      // Check if the last element is a button with 'aria-expanded' set to 'false'
      else if (isButtonCollapsed) {
        // Find the second level dropdown parent
        immediateParentWithSelector = secondLevelElement.parents('.cms-navigation-2019__menu-item--dropdown').eq(1);
        this.collapseMenu(immediateParentWithSelector);
        nextFocusableElement.focus();
        this.hideGeneralOverlay();
        this.enableScrolling();
      }
      // Check if the last element is a button with 'aria-expanded' set to 'true'
      else if (isButtonExpanded) {
        // Check if the button has third level elements
        thirdLevelElements = this.getThirdLevelElements(lastElement);

        if (thirdLevelElements.length > 0) {
          // Added a keydown event listener to the last element in thirdLevelElements
          thirdLevelElements.last().on('keydown', (event) => {
            // Only proceed if the Tab key was pressed without the Shift key
            if (event.key === 'Tab' && !event.shiftKey) {
              // Prevent the default action (moving focus to the next element)
              event.preventDefault();

              // Finding the immediate parent that matches the selector, so used .closest()
              immediateParentWithSelector = secondLevelElement.closest('.cms-navigation-2019__menu-item--dropdown');
              this.collapseMenu(immediateParentWithSelector);

              // Finding the second level parent
              const secondLevelParentWithSelector = immediateParentWithSelector.parents('.cms-navigation-2019__menu-item--dropdown').eq(0);
              this.collapseMenu(secondLevelParentWithSelector);

              // Moving the focus to the next focusable element in the document structure
              nextFocusableElement.focus();
              this.hideGeneralOverlay();
              this.enableScrolling();
            }
          });
        }
      }
    }
  }

  handleShiftTabSecondLevel(event, index, secondLevelElements, topLevelButton) {
    const isIndexZero = index === 0;
    const prevElement = secondLevelElements.eq(index - 1);
    const isPrevElementExpandedButton = prevElement.prop('tagName') === 'BUTTON' && prevElement.attr('aria-expanded') === 'true';
    const thirdLevelItems = this.getThirdLevelElements(prevElement);
    const hasThirdLevelItems = thirdLevelItems.length > 0;

    // Preventing the default 'Shift+Tab' key behavior
    event.preventDefault();

    // Check if current element is the first in the second level menu
    if (isIndexZero) {
      // Move focus to the associated first level menu item
      topLevelButton.focus();
    } else {
      // Check if previous element is a button and 'aria-expanded' attribute is set to 'true'
      // If true, move focus to the last item in the third level, else move focus to the previous second level element
      (isPrevElementExpandedButton && hasThirdLevelItems ? thirdLevelItems[thirdLevelItems.length - 1] : prevElement).focus();
    }
  }
  handleSecondLevelNavigation() {
    // Get all first level elements
    const firstLevelElements = this.getFirstLevelElements();

    // Iterate over each first level element
    firstLevelElements.each((index, element) => {
      const topLevelButton = $(element);


      topLevelButton.on('keydown', (event) => {

        if (event.key === 'Enter' || event.key === ' ') {
          setTimeout(() => {
            if (topLevelButton.attr('aria-expanded') === 'true') {
              const secondLevelElements = this.getSecondLevelElements(topLevelButton);

              // Iterate over each second level element
              secondLevelElements.each((index, element) => {
                const secondLevelElement = $(element);

                secondLevelElement.on('keydown', (event) => {
                  if (event.key === 'Tab' && !event.shiftKey) {
                    this.handleTabSecondLevel(event, index, secondLevelElement, secondLevelElements, topLevelButton, firstLevelElements);
                  }
                  else if (event.key === 'Tab' && event.shiftKey) {
                    this.handleShiftTabSecondLevel(event, index, secondLevelElements, topLevelButton);
                  }
                });
              });
            }
          }, 100); // Delay of 100 milliseconds
        }
      });
    });
  }
  handleEscapeKeyOnNavigation() {
    const hamburger = $('.cms-navigation-2019__hamburger');
    const firstLevelElements = this.getFirstLevelElements();

    $(document).on('keydown', (e) => {
      if (e.key !== 'Escape') return;

      const expandedFirstLevelElement = firstLevelElements.filter((_, el) => $(el).attr('aria-expanded') === 'true');

      if (expandedFirstLevelElement.length > 0) {
        const secondLevelElements = this.getSecondLevelElements(expandedFirstLevelElement);
        const expandedSecondLevelItem = secondLevelElements.filter((_, el) => $(el).attr('aria-expanded') === 'true');

        e.preventDefault();

        if (expandedSecondLevelItem.length > 0) {
          const parentLiSecondLevel = expandedSecondLevelItem.closest('.cms-navigation-2019__menu-item--dropdown');
          this.collapseMenu(parentLiSecondLevel);
          expandedSecondLevelItem.focus();
        } else {
          const parentLi = expandedFirstLevelElement.closest('.cms-navigation-2019__menu-item--dropdown');
          this.collapseMenu(parentLi);
          this.hideGeneralOverlay();
          this.enableScrolling();
          expandedFirstLevelElement.focus();
        }
      } else if (hamburger.hasClass('cms-navigation-2019__hamburger--active')) {
        this.hideGeneralOverlay();
        this.deactivateHamburger();
        this.hideMobileMenu();
        this.enableScrolling();
        hamburger.focus();
      }
    });
  }
  // Method to handle focus shifting in mobile view
  tabOrderMobileView() {
    const logo = $('.cms-navigation-2019__logo');
    const hamburger = $('.cms-navigation-2019__hamburger');
    const marketSegmentsMobile = $('.cms-navigation-2019__market-segment-container--mobile a').toArray();
    const languagesMobile = $('.cms-navigation-2019__language-container--mobile a').toArray();
    const iconMenuFocusableElements = $('.cms-navigation-2019__icon-menu')
      .find('a:visible, button:visible, :input:visible, [tabindex]:visible')
      .not('[tabindex="-1"]')
      .toArray();
    const allMainFocusableElements = this.getAllFocusableElements().toArray();
    //get the DOM element from the hamburgerElement jQuery object before searching for it in the allMainFocusableElements array
    const hamburgerElement = $('.cms-navigation-2019__hamburger')[0];
    const hamburgerIndex = allMainFocusableElements.indexOf(hamburgerElement);
    const nextElement = allMainFocusableElements[hamburgerIndex + 1];
    const initialsButton = $('.cms-navigation-2019__login-status--logged-in');

    const self = this;
    const isMobileView = () => $(window).width() < 841;

    // Helper function to handle shifting of the focus
    const handleFocusShift = (element, condition, target, callback) => {
      element.on('keydown', function (e) {
        if (isMobileView() && e.key === 'Tab' && condition(e)) {
          e.preventDefault();
          target.focus();
          if (callback) {
            callback();
          }
        }
      });
    };

    // When Tab is pressed on logo, move focus to first element in iconMenuFocusableElements
    handleFocusShift(logo,
      (e) => iconMenuFocusableElements.length > 0 && !e.shiftKey,
      $(iconMenuFocusableElements[0])
    );

    // When Tab is pressed on hamburger shift the focus to the first element in marketSegmentsMobile
    handleFocusShift(hamburger,
      (e) => hamburger.hasClass('cms-navigation-2019__hamburger--active') && !e.shiftKey && marketSegmentsMobile.length > 0,
      $(marketSegmentsMobile[0])
    );

    // When Shift + Tab is pressed on hamburger shift the focus to the second last element in iconMenuFocusableElements
    handleFocusShift(hamburger,
      (e) => hamburger.hasClass('cms-navigation-2019__hamburger--active') && e.shiftKey && iconMenuFocusableElements.length > 1,
      $(iconMenuFocusableElements[iconMenuFocusableElements.length - 2])
    );
    // When Tab is pressed on hamburger and it's not active, shift the focus to the next element
    handleFocusShift(hamburger,
      (e) => !hamburger.hasClass('cms-navigation-2019__hamburger--active') && !e.shiftKey,
      $(nextElement)
    );

    // When Shift + Tab is pressed on the next element, shift the focus back to hamburger
    handleFocusShift($(nextElement),
      (e) => e.shiftKey,
      hamburger
    );
    // When Tab is pressed on the last element in languagesMobile shift the focus to the first element in main content and close mobile menu
    handleFocusShift($(languagesMobile[languagesMobile.length - 1]),
      (e) => languagesMobile.length > 0 && !e.shiftKey,
      $(nextElement),
      () => {
        hamburger.attr('aria-expanded', 'false');
        self.hideGeneralOverlay();
        self.hideMobileMenu();
        self.enableScrolling();
        self.collapseAllMenus();
      }
    );

    // When Shift + Tab is pressed on the first element in iconMenuFocusableElements, move focus back to logo
    handleFocusShift($(iconMenuFocusableElements[0]),
      (e) => iconMenuFocusableElements.length > 0 && e.shiftKey,
      logo
    );

    // When Shift + Tab is pressed on the first element in marketSegmentsMobile, move focus back to hamburger if it has the active class
    handleFocusShift($(marketSegmentsMobile[0]),
      (e) => marketSegmentsMobile.length > 0 && e.shiftKey && hamburger.hasClass('cms-navigation-2019__hamburger--active'),
      hamburger
    );

    initialsButton.on('keydown', function (e) {

      // Use setTimeout to delay the check of the conditions in the if statement
      setTimeout(function () {

        let initialsServicesListLinks = $('.cms-login__services-list a');
        let initialsLoggedInLinks = $('.cms-navigation-2019__login-bottom-link-container--logged-in a');
        let combinedLinks = initialsServicesListLinks.add(initialsLoggedInLinks);

        if (isMobileView()) {
          if ((e.key === 'Enter') && !e.shiftKey &&
            ($(initialsButton).attr('aria-expanded') === 'true' || $(closeButton).attr('aria-expanded') === 'true')) {
            e.preventDefault();
            combinedLinks.first().focus();
          }
        }
      }.bind(this), 100); // Binding the the this value to the initials button and setting the delay to 0
    });
  }



  // Method to handle  aria-expanded attribute on the hamburger menu
  toggleAriaExpandedHamburgerMenu() {
    const hamburger = $('.cms-navigation-2019__hamburger');

    hamburger.on('click', () => {
      if (hamburger.hasClass('cms-navigation-2019__hamburger--active')) {
        this.deactivateHamburger();
        this.showChatAndServiceMenu();
      } else {
        this.activateHamburger();
        this.hideChatAndServiceMenu();
      }
    });
  }
  collapseMenu(menuItemDropdown) {
    this.unselectMenuItemDropdown(menuItemDropdown);
    const childMenuItemDropdowns = menuItemDropdown.find('.cms-navigation-2019__menu-item--dropdown');
    this.unselectMenuItemDropdown(childMenuItemDropdowns);
    menuItemDropdown.children('button').attr('aria-expanded', 'false');
    childMenuItemDropdowns.children('button').attr('aria-expanded', 'false'); // set aria-expanded to false on the buttons of the child menu items
  }

  expandMenu(menuItemDropdown) {
    this.selectMenuItemDropdown(menuItemDropdown);
    menuItemDropdown.children('button').attr('aria-expanded', 'true'); // set aria-expanded to true on the button
  }
  closeOtherSameLevelMenus(menuItemDropdown) {
    const otherSameLevelMenus = menuItemDropdown.siblings('.cms-navigation-2019__menu-item--dropdown');
    this.collapseMenu(otherSameLevelMenus);
  }

  unselectMenuItemDropdown(menuItemDropdown) {
    menuItemDropdown.removeClass('cms-navigation-2019__menu-item--selected');
  }

  selectMenuItemDropdown(menuItemDropdown) {
    menuItemDropdown.addClass('cms-navigation-2019__menu-item--selected');
  }

  addGeneralOverlayClickHandler() {
    const overlay = $(
      '.cms-navigation-2019__general-overlay, .cms-navigation-2019__left-overlay-container, .cms-login__left-overlay-container',
    );

    overlay.on('click', () => {
      this.hideLoginArea();
      this.hideMobileMenu();
      this.collapseAllMenus();
      this.hideGeneralOverlay();
      this.enableScrolling();
    });
  }

  addResizeHandler() {
    $(window).on(
      'resize orientationchange',
      _.debounce(() => {
        const isAnyMenuExpanded = this.node.find('.cms-navigation-2019__menu-item--selected').length > 0;
        const isLoginExpanded = this.node.find('.cms-navigation-2019__contents--login').hasClass('cms-navigation-2019__contents--visible');

        if (this.isInDesktopSize()) {
          if (!isAnyMenuExpanded && !isLoginExpanded) {
            this.hideGeneralOverlay();
            this.enableScrolling();
          }
        } else if (this.isMobileMenuOpen()) {
          this.showGeneralOverlay();
          this.disableScrolling();
        }

        this.keepSubMenuInsideWindow();
        this.adjustViewportHeightToAccountForMobileToolbarOnIPhones();
      }, 250),
    );
  }

  showLoginOnDisabledLinkClick() {
    const menuItemLinks = this.node.find('li.cms-navigation-2019__menu-item > a');

    menuItemLinks.on('click', (event) => {
      const clickedLink = $(event.delegateTarget);
      const linkRequiresCredentials = clickedLink.parent().hasClass('cms-navigation-2019__menu-item--disabled');
      const loginLinkWasClicked = clickedLink.parent().hasClass('cms-navigation-2019__menu-item--login');
      const loggedIn = this.isLoggedIn();

      const shouldOpenLoginMenu = loginLinkWasClicked || (!loggedIn && linkRequiresCredentials);

      if (shouldOpenLoginMenu) {
        event.stopPropagation();
        event.preventDefault();
        const redirectUrl = clickedLink.attr('href');
        if (!loginLinkWasClicked) {
          this.eventBus.publish('navigation_menu_redirect_url_update', redirectUrl);
          this.redirectToNewLoginPage('OSPage', redirectUrl, false);
        } else {
          this.redirectToNewLoginPage('currentPage', '', false);
        }
      } else {
        // Logged in but link still locked. Follow link and expect toget a permission denied page.
      }
    });
  }


  /*
  This method is added to identify the Tupas redirect URL correctly, when the Login drawer is opened by clicking Minun Telia menu Items
  */

  addRedirectUrlToTupasLoginButton(redirectUrl) {
    const tupasOkQueryParam = 'tupas-ok';
    let url = this.tupasLink.attr('href');
    if (url.indexOf('successURL') === -1) {
      let successUrl;
      // This redirect URL is used for user clicking on OS link from Minun Telia Menu item.
      successUrl = redirectUrl;
      const contextPath = successUrl.substring(successUrl.indexOf('telia.fi') + 8).trim();
      successUrl = `${contextPath}`;
      if (url.indexOf(tupasOkQueryParam) === -1) {
        successUrl += successUrl.indexOf('?') === -1 ? `?${tupasOkQueryParam}=true` : `&${tupasOkQueryParam}=true`;
      }

      // the successURL is intentionally used ignoring camel cases as the Backend Tupas expects it this way.
      url += `?successURL=${encodeURIComponent(successUrl)}`;
    }
    this.tupasLink.attr('onclick', `window.location.href='${url}'`);
  }

  adjustViewportHeightToAccountForMobileToolbarOnIPhones() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  isInDesktopSize() {
    return $(window).outerWidth() >= 840;
  }

  keepSubMenuInsideWindow() {
    const subMenu = this.node.find('.cms-navigation-2019__menu-item--selected > .cms-navigation-2019__menu--level-3');

    if (this.isInDesktopSize()) {
      const isAnySubMenuVisible = subMenu.length > 0;

      if (isAnySubMenuVisible) {
        const dropDownMenuItem = this.node.find('.cms-navigation-2019__menu--level-2 > .cms-navigation-2019__menu-item--selected');
        const menuItemDimensions = dropDownMenuItem[0].getBoundingClientRect();
        const subMenuDimensions = subMenu[0].getBoundingClientRect();
        const windowHeight = $(window).height();
        const newTop = Math.min(0, windowHeight - (menuItemDimensions.bottom - menuItemDimensions.height + subMenuDimensions.height));
        subMenu.css({ top: newTop });
      }
    } else {
      subMenu.css({ top: 0 });
    }
  }

  makeAdditionalCall() {
    let makeAdditionalCall = false;
    makeAdditionalCall = this.data.makeAdditionalCall;
    if (makeAdditionalCall && (makeAdditionalCall === true)) {
      this.updateNavigationAndLoginSectionInExternalSystems();
    }
  }

  updateNavigationAndLoginSectionInExternalSystems() {
    try {
      let currentUrl = window.location.href;
      let b2cEshopUrl = this.data.b2cEshopUrl;
      let b2bEcommerceUrl = this.data.b2bEcommerceUrl;
      if (currentUrl.startsWith(b2cEshopUrl) || currentUrl.startsWith(b2bEcommerceUrl)) {
        const endpointUrl = `/.rest/login/user/info`
        let loggedInStatus = false;
        $.get(endpointUrl)
          .done((data) => {
            loggedInStatus = data.loggedInStatus;
            if (loggedInStatus) {
              this.updateUserInitialsSection(data);
              this.handleInitialsButtonAriaExpanded();
              this.handleInitialsButtonNavigation();
              this.handleEscapeOnInitialsMenu();
              if (currentUrl.startsWith(b2bEcommerceUrl)) {
                $("#login2020Menu").load('/yrityksille/navigation/0/login/0');
              } else {
                $("#login2020Menu").load('/telia-fi/navigation/0/login/0');
              }
            }
          })
          .fail(() => {
            console.log('failed to invoke rest call in navigation component');
          })
      }
    } catch (e) {
      console.log(e); // eslint-disable-line
    }
  }

  updateUserInitialsSection(data) {
    let existingLoginIconDiv = document.getElementById('loginIconUserInitials');
    // Create a new div element with the new content
    let userInitials = this.getUserInitials(data);
    let newContent = `
      <button class="cms-navigation-2019__login-status cms-navigation-2019__login-status--logged-in" aria-expanded="false" aria-controls="servicesList">
        <span class="cms-navigation-2019__login-user-initials" data-dd-privacy="mask" data-dd-action-name="User initials button">
         ${userInitials}
        </span>
      </button>
      <button style="display: none;" class="cms-navigation-2019__login-close-icon" aria-expanded="false" aria-controls="servicesList" aria-label="Sulkemispainike">
        <svg class="icon icon--2019-close">
        <use xlink:href="/.resources/pride-ui-module/webresources/assets/icons/svg.svg#2019-close"></use>
        </svg>
      </button>
    `;
    // Replace the content of the existing div
    existingLoginIconDiv.innerHTML = newContent;
  }

  getUserInitials(data) {
    if (data && data.user && data.user.firstName && data.user.lastName) {
      let userInitials = data.user.firstName.charAt(0).toUpperCase() + data.user.lastName.charAt(0).toUpperCase();
      return userInitials;
    }
    return ':-)';
  }



}

